import type { Node, XYPosition } from '../types';

/** A node being dragged and where it was when the drag started. */
export type DragItem = { id: string; startPosition: XYPosition };

/** v11 rule: `node.draggable` wins; otherwise the canvas-wide `nodesDraggable`. */
export const isNodeDraggable = (node: Readonly<Node>, nodesDraggable: boolean): boolean =>
  node.draggable ?? nodesDraggable;

/** The grabbed node plus every other selected node, if draggable. Pass the nodes as selected after the drag-start click. */
export const getDragItems = (nodes: readonly Node[], grabbedId: string, nodesDraggable: boolean): DragItem[] =>
  nodes
    .filter((node) => (node.selected || node.id === grabbedId) && !node.hidden && isNodeDraggable(node, nodesDraggable))
    .map((node) => ({ id: node.id, startPosition: node.position }));

/** Where every item is after the pointer moved by `delta` (flow units). */
export const getDraggedPositions = (items: readonly DragItem[], delta: XYPosition): { id: string; position: XYPosition }[] =>
  items.map(({ id, startPosition }) => ({ id, position: { x: startPosition.x + delta.x, y: startPosition.y + delta.y } }));
